import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setEmployeeOvertimeList, setIsLoading } from "../slices/salarySlice";
import * as services from "../services/salaryApi";
import { generateRandomString } from "utils/helper";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";

function useEmployeeSalaryOvertime() {
  const dispatch = useDispatch();
  const employeeOvertimeList = useSelector((state) => state.salary.employeeOvertimeList || [])
  const { currentCompany, currentEmployee } = useSelector((state) => state.company);
  const [pagination, setPagination] = useState({ page: 1, size: 10 });
  const [startDate, setStartDate] = useState(dayjs().startOf("month"))
  const [endDate, setEndDate] = useState(dayjs())
  const [selectedDates, setSelectedDates] = useState(null);
  const paramId = useParams();

  const handleDateChange = (dates) => {
    setSelectedDates(dates);
  };

  const getEmployeeOt = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));

        const start = params.startDate || startDate.format("YYYY-MM-DD");
        const end = params.endDate || endDate.format("YYYY-MM-DD");

        const response = await services.getEmployeeOvertimeLists({
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: paramId.id,
          startDate: start,
          endDate: end,
          page: params.page ?? 0,
          size: params.size ?? 10,
        });

        dispatch(setEmployeeOvertimeList(response.data?.content || []));

        setPagination({
          page: params.page ?? 0,
          size: params.size ?? 10,
          total: response.data?.totalItems,
        });

      } catch (error) {
        alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, paramId.id, dispatch]
  );

  const handleApply = () => {
    getEmployeeOt({
      startDate: selectedDates?.[0]?.format("YYYY-MM-DD"),
      endDate: selectedDates?.[1]?.format("YYYY-MM-DD"),
    });
  };

  useEffect(() => {
    if (currentCompany) {
      getEmployeeOt();
    }
  }, [currentCompany, currentEmployee]);

  return {
    employeeOvertimeList,
    handleDateChange,
    handleApply
  };
}

export default useEmployeeSalaryOvertime;
